import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CommonApiService } from '../shared/services/api/common-api.service';
import { LicensureListComponent } from './licensure-list.component'
import { NgxMaskModule } from 'ngx-mask';



@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgxMaskModule
  ],
  declarations: [
    LicensureListComponent
  ],
  providers: [CommonApiService]
})
export class LicensureModule { }
